import { combineReducers } from 'redux'
import guide from './guide-editor';

const guides = combineReducers({
  guide,
});

export default guides;
